import service from "@/utils/request";

// 首页搜索
export interface indexSearchInter {
  page: number;
  page_size: number;
  key_word: string;
  search_type?: number;
}

export const indexSearchApi = (params: indexSearchInter) => {
  return service({
    url: "/api/v1/index/search",
    method: "get",
    params,
  });
};

// 首页统计数据
export const getHomepageDataApi = () => {
  return service({
    url: "/api/v1/index/count_data",
    method: "get",
  });
};

// 首页购课人数统计
export interface getOrderBuyDataInter {
  start_date: string;
  end_date: string;
}
export const getOrderBuyDataApi = (params: getOrderBuyDataInter) => {
  return service({
    url: "/api/v1/statistics/order_subject_buy_num",
    method: "get",
    params,
  });
};

// 我的学员跟进记录列表
export interface getFollowStudentListInter {
  status: number;
  page?: number;
  page_size?: number;
}
export const getFollowStudentListApi = (params: getFollowStudentListInter) => {
  return service({
    url: "/api/v1/index/my/student_follow_list",
    method: "get",
    params,
  });
};

// WOW学院列表
export interface geTmaterialLibraryInter {
  name?: string;
  type?: number[];
  page?: number;
  page_size?: number;
  sort_type?: string;
  sort_field?: string;
  pid?: number;
}
export const geTmaterialLibraryApi = (params: geTmaterialLibraryInter) => {
  return service({
    url: "/api/v1/org/material/list",
    method: "get",
    params,
  });
};
